import React, { Fragment } from 'react'
import { Calendar } from 'primereact/calendar'
import { Label } from 'reactstrap'
import { timeForDataPicker, dateFormatForDatePicker } from '../../utils/utcTime'

const CustomReactDateTimePicker = (props) => {
  const handleChangeWithoutTimezone = (e) => {
    const { onChange, name } = props
    onChange({
      ...e,
      persist: e.originalEvent.persist,
      target: { name, value: timeForDataPicker(e.value, props.show12Time ? 'MM/DD/YYYY HH:mm' : null) },
    })
  }

  return (
    <Fragment>
      {props.label ? <Label className='text-dark d-block'>{props.label}</Label> : null}
      <Calendar
        baseZIndex={props.baseZIndex}
        value={!props.customValue ? dateFormatForDatePicker(props.value, props.show12Time) : new Date(props.value)}
        onChange={(e) => handleChangeWithoutTimezone(e)}
        dateFormat={!props.dateFormat ? 'mm/dd/yy' : props.dateFormat}
        showTime={props.showTime}
        hourFormat={props.show12Time && '12'}
        showButtonBar={true}
        name={props.name}
        className={`date-picker p-inputtext-sm ${props.customClass || ''}`}
        inputClassName={`date-picker`}
        disabled={props.disabled}
        placeholder={props.placeholder}
        inputStyle={{ border: props.errorMess ? '1px solid red' : '1px solid gray' }}
      />

      <small className='text-danger'>{props.errorMess}</small>
    </Fragment>
  )
}

export default CustomReactDateTimePicker
